<div class="job-editor-content">
  <!-- Meta Section Editor -->
  <div v-if="parsed_active_section === 'meta' && local_document">
    <h6 class="fw-bold mb-4 text-primary">Edit Job Information</h6>
    <div class="row g-4">
      <div class="col-md-6">
        <label class="form-label text-uppercase fw-600 text-xxs">Job Title</label>
        <input type="text" class="form-control form-control-lg" v-model="local_document.meta.post_title" @input="update_field" placeholder="Enter job title">
      </div>
      <div class="col-md-6">
        <label class="form-label text-uppercase fw-600 text-xxs">CORE Code</label>
        <input type="text" class="form-control form-control-lg" v-model="local_document.meta.core_code" @input="update_field" placeholder="Enter CORE code">
      </div>
      <div class="col-md-6">
        <label class="form-label text-uppercase fw-600 text-xxs">Salary Level</label>
        <input type="text" class="form-control form-control-lg" v-model="local_document.meta.post_salary_level" @input="update_field" placeholder="Enter salary level">
      </div>
      <div class="col-md-6">
        <label class="form-label text-uppercase fw-600 text-xxs">Location</label>
        <input type="text" class="form-control form-control-lg" v-model="local_document.meta.location" @input="update_field" placeholder="Enter location">
      </div>
    </div>
  </div>

  <!-- Job Purpose Editor -->
  <div v-else-if="parsed_active_section === 'job_purpose' && local_document">
    <h6 class="fw-bold mb-4 text-primary">Edit Job Purpose</h6>
    <textarea class="form-control form-control-lg" rows="8" v-model="local_document.job_purpose" @input="update_field" placeholder="Describe the overall purpose of this role"></textarea>
    <small class="text-muted mt-2 d-block">
      <i class="bi bi-lightbulb me-1"></i>
      Clearly describe the main purpose and objectives of this position
    </small>
  </div>

  <!-- Main Functions Editor -->
  <div v-else-if="parsed_active_section === 'main_functions' && local_document">
    <h6 class="fw-bold mb-4 text-primary">Edit Main Functions</h6>
    <div class="list-group mb-3">
      <div v-for="(func, idx) in local_document.main_functions" :key="idx" class="list-group-item border-0 bg-light mb-2 p-3 rounded">
        <div class="d-flex gap-3 align-items-center">
          <span class="badge bg-primary d-flex align-items-center justify-content-center size-32">{{ idx + 1 }}</span>
          <input type="text" class="form-control form-control-lg flex-grow-1" v-model="local_document.main_functions[idx]" @input="update_field" placeholder="Enter function description">
          <button class="btn btn-outline-danger btn-sm" @click="remove_function(idx)" title="Remove">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
    </div>
    <button class="btn btn-primary btn-sm" @click="add_function">
      <i class="bi bi-plus-circle me-2"></i>Add Function
    </button>
  </div>

  <div v-else>
    <div class="alert alert-info border-0">
      <i class="bi bi-pencil me-2"></i>
      Editor content for this section will appear here
    </div>
  </div>
</div>
